import PropTypes from "prop-types";
import MDTypography from "components/MDTypography";
import { monoFontSx, MONO_FONT_CLASS } from "styles/tokens/typography";

const MonoText = ({ children, align = "left", variant = "caption", className, ...rest }) => (
  <MDTypography
    component="span"
    variant={variant}
    className={[MONO_FONT_CLASS, className].filter(Boolean).join(" ")}
    data-font="mono"
    sx={{
      ...monoFontSx,
      display: "inline-block",
      width: align === "right" ? "100%" : "auto",
      textAlign: align,
    }}
    {...rest}
  >
    {children}
  </MDTypography>
);

MonoText.propTypes = {
  children: PropTypes.node,
  align: PropTypes.oneOf(["left", "right", "center"]),
  variant: PropTypes.string,
  className: PropTypes.string,
};

export default MonoText;
